// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ol[data-v-8e4c0f88]{counter-reset:item;margin-left:30px}ol>li[data-v-8e4c0f88]{list-style-type:none}ol>li[data-v-8e4c0f88]:before{content:counters(item,\".\") \".\";counter-increment:item;margin-left:-20px;padding-right:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
